import { render } from "./CommunityModal.vue?vue&type=template&id=28376c6a&scoped=true"
import script from "./CommunityModal.vue?vue&type=script&lang=js"
export * from "./CommunityModal.vue?vue&type=script&lang=js"

import "./CommunityModal.vue?vue&type=style&index=0&id=28376c6a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-28376c6a"

export default script